// Copy and poll timing for the drawing owner change (REQ-473).
export const CHANGE_OWNER_MESSAGES = {
	menuItem: "Change owner",
	modalTitle: "Change owner",
	confirm: "Change owner",
	selectPlaceholder: "Search by name",
	noUsers: "No other active users",
	usersFailed: "Couldn't load users. Close and try again.",
	pending: "Changing owner…",
	success: (ownerName: string) => `Owner changed to ${ownerName}`,
	failed: "Owner couldn't be changed. Try again.",
	busy: "The drawing is busy. Try again once it is idle.",
	forbidden: "Only Admins and Super Admins can change the owner of a drawing.",
	notFound: "This drawing no longer exists.",
	unauthorized: "Your session has expired. Sign in again to change the owner.",
	timedOut: "Changing the owner is taking too long. Check the file again in a moment.",
} as const

// The endpoint's own docs recommend polling the job every ~3s.
export const CHANGE_OWNER_POLL_INTERVAL_MS = 3000

// A big drawing takes "a few seconds"; past this the job is reported as taking too long, not polled forever.
export const CHANGE_OWNER_POLL_TIMEOUT_MS = 5 * 60 * 1000
